<template>
	<v-form ref="formDadosEntrevista" fast-fail :disabled="formDesabilitado || loading" @submit.prevent="salvarRequisitos">
		<v-row>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Responsável pela Entrevista</div>
				<v-text-field v-model="form.responsavel" :rules="validarDadosEntrevista.responsavel" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Cargo</div>
				<v-text-field v-model="form.cargo" :rules="validarDadosEntrevista.cargo" />
			</v-col>
			<v-col cols="12" v-for="data, index in form.listaDataHorario" :key="index">
				<v-row>
					<v-col cols="12" md="4">
						<div class="mb-2 mr-6"><span class="required">* </span>Data de Entrevista</div>
						<v-mask-input v-model="data.dataEntrevista" :rules="validarDadosEntrevista.dataEntrevista" readonly append-inner-icon="mdi-calendar-range">
							<v-dialog :key="`modal-data-${index}`" v-model="mostraDataEntrevista[index]" activator="parent" width="auto">
								<v-date-picker v-model="data.unformattedData" elevation="24" :min="dataAtual" @update:model-value="data.dataEntrevista = format(data.unformattedData, 'dd/MM/yyyy')" />
							</v-dialog>
						</v-mask-input>
					</v-col>
					<v-col cols="12" md="3">
						<div class="mb-2 mr-6"><span class="required">* </span>Horário da Entrevista</div>
						<v-text-field v-model="data.horarioEntrevista" :rules="validarDadosEntrevista.horarioEntrevista" readonly>
							<v-dialog :key="`modal-hora-${index}`" v-model="mostraSelecionarHorarioEntrevista[index]" activator="parent" width="auto">
								<v-time-picker v-model="data.horarioEntrevista" format="24hrs" />
							</v-dialog>
						</v-text-field>
					</v-col>
					<v-col cols="12" md="2" class="align-content-center">
						<v-btn v-if="form.listaDataHorario.length === (index + 1) && !formDesabilitado" size="small" color="primary" :loading="loading" icon="mdi-plus" :disabled="formDesabilitado || loading || !data.unformattedData" @click="addDataHora" />
						<v-btn v-if="form.listaDataHorario.length > 1 && !formDesabilitado" size="small" color="error" :loading="loading" icon="mdi-trash-can-outline" class="ml-2" :disabled="formDesabilitado || loading" @click="removeDataHora(index)" />
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Local da Entrevista</div>
				<v-text-field v-model="form.local" :hint="dicaEntrevista" :rules="validarDadosEntrevista.local" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Data para Retorno da(s) Carta(s) de Encaminhamento</div>
				<v-mask-input v-model="form.dataRetorno" :rules="validarDadosEntrevista.dataRetorno" readonly append-inner-icon="mdi-calendar-range">
					<v-dialog v-model="mostraDataRetorno" activator="parent" width="auto">
						<v-date-picker v-model="dataRetorno" elevation="24" :min="dataMinRetorno" @update:model-value="form.dataRetorno = format(dataRetorno, 'dd/MM/yyyy')" />
					</v-dialog>
				</v-mask-input>
			</v-col>
		</v-row>
		<v-row v-if="!escondeBotoes">
			<v-col cols="6" align="start">
				<v-btn :color="corTexto" variant="outlined" :loading="loading" @click="voltarPasso">
					VOLTAR
				</v-btn>
			</v-col>
			<v-col cols="6" align="end">
				<v-btn color="primary" type="submit" :loading="loading" :disabled="formDesabilitado || desabilitaAvancar">
					{{ modoSolicitacao ? "SALVAR" : "CONCLUIR" }}
				</v-btn>
			</v-col>
		</v-row>
		<v-dialog v-model="exibeModal" width="auto" persistent>
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Solicitação enviada com sucesso!</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="router.push('/vagas/lista')"
					></v-btn>
				</template>
				<div class="px-4">
					Sua solicitação de cadastro da vaga foi registrada com o <b>protocolo #{{ protocolo || dataVaga.value.protocolo }}.</b> Você poderá acompanhar o andamento no menu <b>Acompanhar Vagas.</b>
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="6" class="text-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="VOLTAR"
							@click="router.push('/vagas/lista')"
						></v-btn>
					</v-col>
					<v-col cols="6" class="text-center">
						<v-btn
							block
							color="primary"
							text="NOVA VAGA"
							@click="router.push('/vagas/nova')"
						></v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</v-form>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { validarDadosEntrevista } from '@/utils/ValidacoesUtils';
import { ConfirmacaoAlert } from "@/utils/AlertUtils.js";
import { useRoute, useRouter } from 'vue-router';
import { vagasEnum } from '@/utils/VagaUtils';
import { cadastrarVaga, editarVaga } from '@/services/VagaService';
import { format } from "date-fns";
import { ErroAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'


const route = useRoute();
const router = useRouter();
const emit = defineEmits(["passoAnterior", "proximoPasso"]);
const props = defineProps({
	dadosEntrevistaForm: Object,
	dataVaga: Object,
	formDesabilitado: Boolean,
	escondeBotoes: Boolean,
	modoSolicitacao: Boolean,
});

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
})

const loading = ref(false);
const editando = ref(false);
const exibeModal = ref(false);
const protocolo = ref();
const mostraSelecionarHorarioEntrevista = ref([false]);
const mostraDataEntrevista = ref([false]);
const mostraDataRetorno = ref(false);
const dataRetorno = ref();
const dataAtual = new Date();
const formDadosEntrevista = ref();
const form = ref({
	id: editando ? Number(route.params?.id) : undefined,
	responsavel: undefined,
	cargo: undefined,
	listaDataHorario: [{ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined }],
	local: undefined,
	dataRetorno: undefined,
})

const dicaEntrevista = ref(`O SINE acredita que a entrevista presencial é a melhor forma de encontrar o candidato certo para sua vaga.
	A interação entre empregador e candidato permite uma avaliação mais completa do trabalhador e aumenta as chances de uma contratação bem-sucedida.
	Recepcione e entreviste os candidatos encaminhados por este serviço!`);

async function salvarRequisitos() {
	await formDadosEntrevista.value.validate();
	if (!formDadosEntrevista.value.isValid) {
		return;
	}
	const bodyRequest = ref({
		id: editando.value ? Number(form.value.id) : undefined,
		stepCadastroVaga: vagasEnum[3],
		dadosEntrevista: {
			responsavel: form.value.responsavel,
			cargo: form.value.cargo,
			local: form.value.local,
			listaDataHorario: form.value.listaDataHorario.map((data) => {
				return {
					id: data.id ? data.id : null,
					dataEntrevista: data.dataEntrevista,
					horarioEntrevista: data.horarioEntrevista,
				}
			}),
			dataRetorno: form.value.dataRetorno,
		}
	})
	if (!editando.value) {
		loading.value = true;
		await cadastrarVaga({
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(({ data }) => {
				exibeModal.value = true;
				protocolo.value = data.protocolo;
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao salvar dados da entrevista. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
	else {
		loading.value = true;
		await editarVaga(bodyRequest.value.id || 0,
			{
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(({ data }) => {
				if (props.modoSolicitacao) {
					emit("proximoPasso");
					return;
				}
				exibeModal.value = true;
				protocolo.value = data.protocolo;
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao editar dados da entrevista. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
}

const dataMinRetorno = computed(() => {
	if (!form.value.listaDataHorario.length) {
		return new Date();
	}
	if (form.value.listaDataHorario.length === 1) {
		if (!form.value.listaDataHorario[0].dataEntrevista) {
			return new Date();
		}

		const [dia, mes, ano] = form.value.listaDataHorario[0].dataEntrevista.split("/");
		const novaData = new Date(+ ano, + mes - 1, + dia);
		return novaData;
	}

	const order = [...form.value.listaDataHorario].sort((a, b) => new Date(a.unformattedData) - new Date(b.unformattedData));

	const [dia, mes, ano] = order[order.length - 1].dataEntrevista.split("/");
	const novaData = new Date(+ ano, + mes - 1, + dia);

	return novaData;
});

const desabilitaAvancar = computed(() => {
    const ignorarCampos = ["id", "listaDataHorario"];
    const formBasicoValido = Object.keys(form.value).every(key => {
        if (ignorarCampos.includes(key)) {
            return true;
        }
        return !!form.value[key] && form.value[key] !== "";
    });
    const listaValida = (() => {
        const lista = form.value.listaDataHorario;
        if (!lista || !Array.isArray(lista) || lista.length === 0) {
            return false;
        }

        return lista.every(item => {
            if (!item) return false;

            return !!item.dataEntrevista?.trim() &&
                   !!item.horarioEntrevista?.trim();
        });
    })();
    const contemErro = formDadosEntrevista.value?.errors?.length > 0;

    return !formBasicoValido || !listaValida || contemErro;
});

function addDataHora() {
	form.value.listaDataHorario.push({ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined });
	mostraSelecionarHorarioEntrevista.value.push(false);
	mostraDataEntrevista.value.push(false);
}

function removeDataHora(index) {
	form.value.listaDataHorario.splice(index, 1);
	mostraSelecionarHorarioEntrevista.value.splice(index, 1);
	mostraDataEntrevista.value.splice(index, 1);
}

async function voltarPasso() {
	if (props.formDesabilitado) {
		emit("passoAnterior");
		return;
	}
	ConfirmacaoAlert({
		title: "Deseja voltar?",
		message: "Ao voltar você pode perder as informações não salvas nesse formulário",
		onConfirm: () => emit("passoAnterior"),
		confirmText: "Voltar",
		cancelText: "Cancelar",
		showCancelButton: true,
	});
}

watch(() => props, () => {
	if (props.dadosEntrevistaForm) {
		form.value = props.dadosEntrevistaForm;
	}
}, { deep: true, immediate: true });

watch(form.value.listaDataHorario, () => {
	let dataMaiorUn = new Date();
	let dataMaior = new Date();
	if (!form.value.listaDataHorario.length) {
		dataRetorno.value = new Date();
		form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
		return
	}
	if (form.value.listaDataHorario.length === 1) {
		if (!form.value.listaDataHorario[0].dataEntrevista) {
			dataRetorno.value = new Date();
			form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
			return
		}

		if (dataRetorno.value) {
			dataMaiorUn = new Date(form.value.listaDataHorario[0].unformattedData);
			dataMaiorUn.setDate(dataMaiorUn.getDate() + 10)
			if (dataMaiorUn >= dataRetorno.value) {
				dataRetorno.value = dataMaiorUn;
				form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
				return
			}
			return
		}
		dataRetorno.value = new Date();
		dataRetorno.value.setDate(form.value.listaDataHorario[0].unformattedData.getDate() + 10);
		form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
		return
	}
	const order = [...form.value.listaDataHorario].sort((a, b) => new Date(a.unformattedData ? a.unformattedData : 0) - new Date(b.unformattedData ? b.unformattedData : 0));
	if (dataRetorno.value) {
		dataMaior = new Date(order[order.length - 1].unformattedData);
		dataMaior.setDate(dataMaior.getDate() + 10)
		if (dataMaior >= dataRetorno.value) {
			dataRetorno.value = dataMaior;
			form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
			return
		}
		return
	}
	dataRetorno.value = new Date();
	dataRetorno.value.setDate(order[order.length - 1].unformattedData.getDate() + 10);
	form.value.dataRetorno = format(dataRetorno.value, "dd/MM/yyyy");
	return
}, { deep: true });

onMounted(async () => {
	if (!isNaN(route.params?.id)) {
		editando.value = true;
	}
});
</script>
<style lang="css" scoped>
.radio {
	display: inline-flex;
}
.required {
	color: red;
}
</style>